<div class="w-full bg-white flex flex-col gap-6 items-center my-6">
    <img [src]="cdnUrl + '/images/empty-view.png'" height="140" width="170" alt="واحد اقامتی پیدا نشد">
    <p class="text-black-400 text-base text-center">
        متاسفانه هیچ واحد اقامتی با مشخصات خواسته شده در این تاریخ پیدا نشد!
    </p>
    <div class="iho-datepicker">
    <button matRipple matRippleColor="primary" ihoDatepicker (click)="openDatepicker()" [matRippleColor]="'primary'"
        class="w-60 primary-border rounded-lg py-2 text-blue">تغییر تاریخ</button>
    </div>
</div>